import {
  CHART_LOADING_DONE,
  CLEAR_CHART,
  CLEAR_DASHBOARD,
  GET_DASHBOARD,
  GET_LAST_DEPOSITS,
  GET_LAST_SETTLEMENTS,
  GET_TRANSACTIONS_CHART,
  UPLOAD_ACTIVE_TERMINAL,
} from 'redux/actions/types';

const initialState = {
  isLoading: true,
  chartLoading: true,
  wallets: null,
  terminals: null,
  userData: null,
  deposits: null,
  settlements: null,
  activeTerminal: null,
};

const dashboard = (state = initialState, { type, data }) => {
  switch (type) {
    case GET_DASHBOARD:
      return {
        ...state,
        wallets: data.wallets || [],
        terminals: data.terminals || [],
        userData: data.statistics || [],
        isLoading: false,
      };
    case GET_LAST_DEPOSITS:
      return {
        ...state,
        deposits: data?.transactions || [],
      };
    case GET_LAST_SETTLEMENTS:
      return {
        ...state,
        settlements: data?.transactions || [],
      };
    case GET_TRANSACTIONS_CHART:
      return {
        ...state,
        transactions: data?.transactions,
        checkouts: data?.checkouts,
      };
    case UPLOAD_ACTIVE_TERMINAL:
      return {
        ...state,
        activeTerminal: data,
      };
    case CLEAR_DASHBOARD:
      return {
        isLoading: true,
      };
    case CLEAR_CHART:
      return {
        ...state,
        chartLoading: true,
      };
    case CHART_LOADING_DONE:
      return {
        ...state,
        chartLoading: false,
      };

    default:
      return state;
  }
};

export default dashboard;
